import { RewardId } from './RewardTypes';

/**
 * Configuration for a single reward type
 */
export interface RewardConfig {
  /** Unique identifier for this reward */
  id: RewardId;

  /** Chance to spawn (0-1, where 1 = 100% chance) */
  chanceToSpawn: number;

  /** Base amount of this reward */
  amount: number;

  /** Maximum amount (if provided, actual amount will be random between amount and maxAmount) */
  maxAmount?: number;
}

/**
 * Master configuration for all possible rewards in the game.
 *
 * Notes:
 * - Gold amounts are computed from player gold at entry (1%–5% × dungeonLevel × chest multiplier); see GoldRewardConfig.ts
 * - chanceToSpawn is a probability from 0 to 1
 * - First chest always gets GOLDEN_KEY regardless of config
 */
export const REWARD_CONFIGS: RewardConfig[] = [
  {
    id: RewardId.GOLDEN_KEY,
    chanceToSpawn: 0, // 15% chance (not used for first chest)
    amount: 1,
  },
  {
    id: RewardId.GOLD,
    chanceToSpawn: 0.45, // 60% chance — amount computed from player gold at entry × level × chest multiplier
    amount: 0,
  },
  {
    id: RewardId.TORCH,
    chanceToSpawn: 0.25, // 20% chance
    amount: 1,
  },
  {
    id: RewardId.GRAY_KEY,
    chanceToSpawn: 0.20, // 10% chance
    amount: 1,
  },
  {
    id: RewardId.EXPLOSION,
    chanceToSpawn: 0,
    amount: 1,
  },
  {
    id: RewardId.NOTHING,
    chanceToSpawn: 0.1,
    amount: 0,
  },
];

/**
 * Get reward configuration by ID
 */
export function getRewardConfig(id: RewardId): RewardConfig | undefined {
  return REWARD_CONFIGS.find(config => config.id === id);
}